import { ThreeSixty } from './resources/ThreeSixty';
import { Alert } from './resources/Alert';
import { UkFerryPort } from './resources/UkFerryPort';
import { Area } from './resources/Area';
import { ArrowUp } from './resources/ArrowUp';
import { ArrowRight } from './resources/ArrowRight';
import { ArrowDown } from './resources/ArrowDown';
import { ArrowLeft } from './resources/ArrowLeft';
import { ArrowFullUp } from './resources/ArrowFullUp';
import { ArrowFullRight } from './resources/ArrowFullRight';
import { ArrowFullDown } from './resources/ArrowFullDown';
import { ArrowFullLeft } from './resources/ArrowFullLeft';
import { Bath } from './resources/Bath';
import { Bed } from './resources/Bed';
import { Bell } from './resources/Bell';
import { Calculator } from './resources/Calculator';
import { Calendar } from './resources/Calendar';
import { Camera } from './resources/Camera';
import { Car } from './resources/Car';
import { Chair } from './resources/Chair';
import { CheckboxTick } from './resources/CheckboxTick';
import { Clear } from './resources/Clear';
import { Close } from './resources/Close';
import { Cog } from './resources/Cog';
import { LondonDlrStation } from './resources/LondonDlrStation';
import { Document } from './resources/Document';
import { Draw } from './resources/Draw';
import { EmailFill } from './resources/EmailFill';
import { EmailOutline } from './resources/EmailOutline';
import { EyeClosed } from './resources/EyeClosed';
import { EyeOpen } from './resources/EyeOpen';
import { Facebook } from './resources/Facebook';
import { Filters } from './resources/Filters';
import { Flag } from './resources/Flag';
import { Floorplan } from './resources/Floorplan';
import { Graph } from './resources/Graph';
import { Help } from './resources/Help';
import { HtbLogo } from './resources/HtbLogo';
import { History } from './resources/History';
import { House } from './resources/House';
import { Info } from './resources/Info';
import { Instagram } from './resources/Instagram';
import { Link } from './resources/Link';
import { LinkedIn } from './resources/LinkedIn';
import { LocationPin } from './resources/LocationPin';
import { LocationArrow } from './resources/LocationArrow';
import { Menu } from './resources/Menu';
import { MenuMore } from './resources/MenuMore';
import { Minus } from './resources/Minus';
import { MoneyHouse } from './resources/MoneyHouse';
import { Padlock } from './resources/Padlock';
import { Pencil } from './resources/Pencil';
import { Phone } from './resources/Phone';
import { PhoneOutline } from './resources/PhoneOutline';
import { Pinterest } from './resources/Pinterest';
import { UkAirport } from './resources/UkAirport';
import { Play } from './resources/Play';
import { Plus } from './resources/Plus';
import { Profile } from './resources/Profile';
import { Reset } from './resources/Reset';
import { Ruler } from './resources/Ruler';
import { SaveFilled } from './resources/SaveFilled';
import { SaveOutline } from './resources/SaveOutline';
import { Schools } from './resources/Schools';
import { Search } from './resources/Search';
import { SearchSuggest } from './resources/SearchSuggest';
import { SignOut } from './resources/SignOut';
import { Sort } from './resources/Sort';
import { Star } from './resources/Star';
import { Tick } from './resources/Tick';
import { ThinTickCircle } from './resources/ThinTickCircle';
import { TickCircle } from './resources/TickCircle';
import { Train } from './resources/Train';
import { NationalRailStation } from './resources/NationalRailStation';
import { LondonUndergroundStation } from './resources/LondonUndergroundStation';
import { LondonOvergroundStation } from './resources/LondonOvergroundStation';
import { Settings } from './resources/Settings';
import { Twitter } from './resources/Twitter';
import { ValidationInvalid } from './resources/ValidationInvalid';
import { ValidationValid } from './resources/ValidationValid';
import { Youtube } from './resources/Youtube';
var icons = {
  '360': ThreeSixty,
  alert: Alert,
  uk_ferry_port: UkFerryPort,
  area: Area,
  arrow_up: ArrowUp,
  arrow_right: ArrowRight,
  arrow_down: ArrowDown,
  arrow_left: ArrowLeft,
  arrow_full_up: ArrowFullUp,
  arrow_full_right: ArrowFullRight,
  arrow_full_down: ArrowFullDown,
  arrow_full_left: ArrowFullLeft,
  bath: Bath,
  bed: Bed,
  bell: Bell,
  calculator: Calculator,
  calendar: Calendar,
  camera: Camera,
  car: Car,
  chair: Chair,
  checkbox_tick: CheckboxTick,
  clear: Clear,
  close: Close,
  cog: Cog,
  london_dlr_station: LondonDlrStation,
  document: Document,
  draw: Draw,
  email_fill: EmailFill,
  email_outline: EmailOutline,
  eye_closed: EyeClosed,
  eye_open: EyeOpen,
  facebook: Facebook,
  filters: Filters,
  flag: Flag,
  floorplan: Floorplan,
  graph: Graph,
  help: Help,
  htb_logo: HtbLogo,
  history: History,
  house: House,
  info: Info,
  instagram: Instagram,
  link: Link,
  linkedin: LinkedIn,
  location_pin: LocationPin,
  locationArrow: LocationArrow,
  menu: Menu,
  menuMore: MenuMore,
  minus: Minus,
  money_house: MoneyHouse,
  padlock: Padlock,
  pencil: Pencil,
  phone: Phone,
  phone_outline: PhoneOutline,
  pinterest: Pinterest,
  uk_airport: UkAirport,
  play: Play,
  plus: Plus,
  profile: Profile,
  reset: Reset,
  ruler: Ruler,
  save_filled: SaveFilled,
  save_outline: SaveOutline,
  schools: Schools,
  search: Search,
  searchsuggest: SearchSuggest,
  signout: SignOut,
  sort: Sort,
  star: Star,
  tick: Tick,
  thin_tick_circle: ThinTickCircle,
  tick_circle: TickCircle,
  train: Train,
  national_rail_station: NationalRailStation,
  london_underground_station: LondonUndergroundStation,
  london_overground_station: LondonOvergroundStation,
  settings: Settings,
  twitter: Twitter,
  validation_invalid: ValidationInvalid,
  validation_valid: ValidationValid,
  youtube: Youtube
};
export default icons;
//# sourceMappingURL=icons.js.map